import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { CancelReportJobQueueInput } from './CancelReportJobQueueInput';
import { CancelReportJobQueueOutput } from './CancelReportJobQueueOutput';

export class CancelReportJobQueueService extends HttpServiceBase {

  handle = (input: CancelReportJobQueueInput): Promise<Result<CancelReportJobQueueOutput> | null> => {
    const promise = this.http.post<Result<CancelReportJobQueueOutput>, CancelReportJobQueueInput>(`${this.baseUrlSislogApi}/v2/report-job-queue/${input.id}/cancel`, input);
    return promise;
  }
}